import { render } from "./tableColGroupByPc.vue?vue&type=template&id=12d88eba&ts=true"
import script from "./tableColGroupByPc.vue?vue&type=script&lang=ts"
export * from "./tableColGroupByPc.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__